import { ACTIONS } from "app/store/actions"
import { Action } from "redux"

export interface IAgencySetStripeUserId extends Action {
  agencyId: number
}

export const agencyActionCreator = {
  setStripeUserId(agencyId: number): IAgencySetStripeUserId {
    return {
      type: ACTIONS.AGENCY_SET_STRIPE_USER_ID,
      agencyId
    }
  }
}
